module.exports = __webpack_public_path__ + "img/6509.46d5837e.jpg";